import { action, makeObservable, observable } from 'mobx';
import { gameResultStore, roundInfoStore } from '@pascal/pascal-core/shared/core/store';
import { CARD_BACKSIDE_TYPES } from '../enums/cardTypes';

class CardsStore {
  boxCards = [];

  dealerCards = [];

  selectedCardType = CARD_BACKSIDE_TYPES[0];

  selectedCardBackSideType = 'backside-1';

  constructor() {
    makeObservable(this, {
      selectedCardType: observable,
      selectedCardBackSideType: observable,
      boxCards: observable.deep,
      dealerCards: observable.deep,
      updateBoxCards: action.bound,
      setDealerCards: action.bound,
      updateDealerCards: action.bound,
      updateRoundCards: action.bound,
      setSelectedCardType: action.bound,
      setSelectedCardBackSideType: action.bound,
    });
  }

  updateBoxCards(card) {
    this.boxCards = [...this.boxCards, card];
  }

  updateDealerCards(card) {
    this.dealerCards = [...this.dealerCards, card];
  }

  setDealerCards(cards) {
    this.dealerCards = cards;
  }

  updateRoundCards(card, roundId) {
    const isCardInBoxCards = this.boxCards.find((item) => item.index === card.index);
    const isCardInDealerCards = this.dealerCards.find((item) => item.index === card.index);
    if (!isCardInBoxCards && !isCardInDealerCards) {
      const results = [...gameResultStore.gameResults];
      const cardIndex = results.findIndex((item) => item.index === card.index);
      if (cardIndex > -1) {
        results.splice(cardIndex, 1, card);
        gameResultStore.setGameResults(results);
      }
      if (roundInfoStore.roundId === roundId) {
        if (!card?.boxIndex) {
          this.updateDealerCards(card);
        } else {
          this.updateBoxCards(card);
        }
      }
    }
  }

  setSelectedCardType(type) {
    this.selectedCardType = type;
  }

  setSelectedCardBackSideType(type) {
    this.selectedCardBackSideType = type;
  }

  resetCardsInfo() {
    this.boxCards = [];
    this.dealerCards = [];
  }
}

export const cardsStore = new CardsStore();
